import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (notifications) =>
    present(
      repository
        .editNotificationsStatus(notifications)
        .then(() => notifications)
        .catch(() => Promise.reject(notifications)),
    );
}

export type { Interactor };

export { createInteractor };
